export default __webpack_public_path__ + "static/logo-designs-06-8ff2b905ca353b2f7d91fea4a48600f3.svg";